import type React from "react";
import { useCallback, useState } from "react";
import { PickerSearchInput } from "./picker-search-input.tsx";

interface TitleInputProps {
  onSubmit: (title: string) => void;
  /** Previously entered value — pre-fills the input. */
  defaultValue?: string | null;
}

/** Simple text input for the meeting title step. Pressing Enter or Tab submits. */
export function TitleInput({ onSubmit, defaultValue }: TitleInputProps) {
  const [title, setTitle] = useState(defaultValue ?? "");

  const handleKeyDown = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === "Enter" || (e.key === "Tab" && !e.shiftKey)) {
        e.preventDefault();
        e.stopPropagation();
        onSubmit(title.trim());
      }
    },
    [title, onSubmit],
  );

  return (
    <div className="px-3 py-2">
      <PickerSearchInput
        type="text"
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={handleKeyDown}
        onClear={() => setTitle("")}
        placeholder="What's this about? (optional)"
        autoFocus
      />
    </div>
  );
}
